module.exports = __webpack_public_path__ + "img/default-flask.a3d7647f.svg";